import React from "react";

export const ContentIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00065 14.9792C4.31875 14.9792 1.33398 11.9944 1.33398 8.31251C1.33398 4.63061 4.31875 1.64584 8.00065 1.64584C11.6825 1.64584 14.6673 4.63061 14.6673 8.31251C14.6673 11.9944 11.6825 14.9792 8.00065 14.9792ZM8.00065 13.6458C10.9462 13.6458 13.334 11.258 13.334 8.31251C13.334 5.36699 10.9462 2.97918 8.00065 2.97918C5.05513 2.97918 2.66732 5.36699 2.66732 8.31251C2.66732 11.258 5.05513 13.6458 8.00065 13.6458ZM7.08192 5.92224L10.3345 8.09064C10.4571 8.17231 10.4902 8.33791 10.4085 8.46044C10.3889 8.48971 10.3638 8.51484 10.3345 8.53438L7.08192 10.7028C6.95938 10.7845 6.79378 10.7514 6.71212 10.6288C6.68292 10.585 6.66732 10.5336 6.66732 10.4809V6.14412C6.66732 5.99684 6.78672 5.87745 6.93398 5.87745C6.98665 5.87745 7.03812 5.89303 7.08192 5.92224Z"
        fill="currentColor"
      />
    </svg>
  );
};
